const subscriptionManageKeys = {
  // Dialog and Steps
  "subscription.manage.dialog.step.select.title": "Update Subscription",
  "subscription.manage.dialog.step.review.title": "Review Changes",
  "subscription.manage.dialog.step.review.action": "Update Plan",

  // Notifications
  "subscription.manage.notification.success.title": "Updated Successfully",
  "subscription.manage.notification.success.message": "Yay! Your subscription has been updated. Thank you for staying with us.",
  "subscription.manage.notification.success.scheduled.title": "Change Scheduled",
  "subscription.manage.notification.success.scheduled.message":
    "Your subscription change has been scheduled and will take effect at the start of your next billing period.",
  "subscription.manage.notification.error.title": "Error Updating Subscription",
  "subscription.manage.notification.error.message": "An error occurred while updating your subscription. Please try again.",

  // Select Step
  "subscription.manage.select.current": "Current Subscription",
  "subscription.manage.select.total-seats": "Total Seats",
  "subscription.manage.select.subscription": "Subscription",
  "subscription.manage.select.add-remove": "Add or Remove Seats",
  "subscription.manage.select.need-more": "Need more profiles?",
  "subscription.manage.select.contact-us": "Click here to contact us!",
  "subscription.manage.select.insufficient-seats":
    'You cannot reduce to {{newQuantity}} seats as your team currently has {{teamSize}} members. Please go to "Team Management" to remove members before reducing your subscription.',
  "subscription.manage.select.continue-prompt": 'Click "Continue" to see how these changes will affect your subscription.',

  // Promo Code Messages
  "subscription.manage.promo.error.required": "Please enter a promo code",
  "subscription.manage.promo.error.invalid": "Invalid promo code",
  "subscription.manage.promo.error.minimum-amount":
    "This promo code requires a subscription plan with a higher base price. Please upgrade to an annual plan or contact support for assistance.",
  "subscription.manage.promo.billing-reset-notice":
    "This update will start a new billing period immediately. You'll receive credit for any unused time from your current period.",

  // Review Step
  "subscription.manage.review.subscription": "Subscription",
  "subscription.manage.review.seat-change": "Seat change",
  "subscription.manage.review.new-total": "New total",
  "subscription.manage.review.total-due": "Total Due Now",
  "subscription.manage.review.seats": "seats",
  "subscription.manage.review.for-period": "for {{startDate}} - {{endDate}}",
  "subscription.manage.review.deferred-change": "No charge now. This change will take effect on {{date}}.",
  "subscription.manage.review.added-seats-charge": "Charge for {{count}} additional seat(s) for {{startDate}} - {{endDate}}",

  // Adjustments Section
  "subscription.manage.review.prorated-adjustment": "Prorated Adjustment",
  "subscription.manage.review.applied-discount": "Applied Discount",
  "subscription.manage.review.applied-discounts-multiple": "Applied Discounts",
  "subscription.manage.review.discount-percent": "({{percent}}% off)",
  "subscription.manage.review.credit-added": "Credit Added",
  "subscription.manage.review.applied-savings": "Applied Savings",

  // Info Messages
  "subscription.manage.info.subscription-change":
    "Your change in subscription resulted in a prorated adjustment for the unused portion of your previous plan. This credit will be applied to future charges.",
  "subscription.manage.info.credit-added": "A credit has been added to your account and will be available for future charges.",
  "subscription.manage.info.savings-applied": "Savings from previously removed seats have been automatically applied to this purchase.",
  "subscription.manage.info.decrease-seats":
    "A decrease in seats resulted in a prorated adjustment. This amount will be credited to your account for future charges.",
  "subscription.manage.info.charged-remaining": "You will only be charged for the new seats for the remaining time in your current billing period.",
  "subscription.manage.info.renewal":
    "Your total seats will {{action}} to {{count}}. Your plan will renew on {{date}} for {{amount}} per {{interval}}.",
  "subscription.manage.info.increase": "increase",
  "subscription.manage.info.decrease": "decrease",
  "subscription.manage.info.year": "year",
  "subscription.manage.info.month": "month",
  "subscription.manage.info.deferred-decrease":
    "Your subscription will decrease to {{count}} seats on {{date}}. Your next charge will be {{amount}} per {{interval}}.",
  "subscription.manage.info.custom-invoice-added-seats":
    "You will be charged now for the additional seats for the remainder of your current billing period. Starting {{date}}, your subscription will have {{count}} seats and renew at {{amount}} per {{interval}}.",

  // Subscription Types
  "subscription.manage.type.yearly": "Yearly Subscription",
  "subscription.manage.type.monthly": "Monthly Subscription",
};

export const subscriptionManage = {
  ...subscriptionManageKeys,
};
